import styled, { css } from 'styled-components';
import { ButtonProp } from '@types';
import memoize from 'fast-memoize';

const getStyle = memoize((textColor: string, bgColor: string, hasBorder: boolean) => {
    return css`
        color: ${textColor};
        background: ${bgColor};
        border: ${hasBorder ? `2px solid ${textColor}` : 'none'};
    `;
});

const stylesDef = memoize((theme: any, themeType: string, variant: string, color: string) => {
    if (themeType) {
        const { textColor, bgColor } = theme['button'][themeType];
        return getStyle(textColor, bgColor, false);
    } else if (variant == 'outlined') {
        return getStyle(color || theme.colors.blue, theme.colors.pureWhite, true);
    } else if (variant == 'solid') {
        return getStyle(theme.colors.white, color || theme.colors.blue, false);
    } else {
        return getStyle(color || theme.colors.black, theme.colors.white, false);
    }
});

export const StyledButton = styled.button<ButtonProp>`
    text-transform: ${({ textTransform }) => textTransform || 'uppercase'};
    font-weight: ${({ theme, fontWeight }) => theme['font']['weights'][fontWeight] || 'bold'};
    letter-spacing: 0;
    line-height: 1.188rem;
    font-size: 14px;
    border-radius: 4px;
    text-align: center;
    padding: 8px 13px;
    width: max-content;
    ${({ theme, themeType, variant, color }) => stylesDef(theme, themeType, variant, color)};
`;
